(function () {
  'use strict';
  var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll('.sub__form').forEach(function (form) {
    var input = form.querySelector('.sub__input');
    var msg = form.parentElement.querySelector('.sub__msg');
    var submit = form.querySelector('.sub__submit');
    if (!input || !msg || !submit) return;

    var publicKey = form.getAttribute('data-klaviyo-public-key') || '';
    var listId = form.getAttribute('data-klaviyo-list-id') || '';

    var syncMsgVisibility = function () {
      if (msg.textContent.trim()) msg.classList.add('is-visible');
      else msg.classList.remove('is-visible');
    };
    new MutationObserver(syncMsgVisibility).observe(msg, { childList: true, characterData: true, subtree: true });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      msg.classList.remove('sub__msg--ok');
      var v = (input.value || '').trim();
      if (!v) { msg.textContent = 'Please add an email address.'; input.focus(); return; }
      if (!re.test(v)) { msg.textContent = 'That doesn’t look like a valid email.'; input.focus(); return; }

      if (!publicKey || !listId) {
        msg.classList.add('sub__msg--ok');
        msg.textContent = 'Thank you — your first letter arrives soon.';
        input.value = '';
        return;
      }

      submit.disabled = true;
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            list_id: listId,
            custom_source: 'lovesundaily website footer',
            profile: { data: { type: 'profile', attributes: { email: v } } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(body)
      })
      .then(function (r) {
        if (!r.ok) throw new Error('subscribe failed');
        msg.classList.add('sub__msg--ok');
        msg.textContent = 'Thank you — your first letter arrives soon.';
        input.value = '';
      })
      .catch(function () {
        msg.textContent = 'Something went wrong. Please try again in a moment.';
      })
      .finally(function () { submit.disabled = false; });
    });

    input.addEventListener('input', function () { if (msg.textContent) msg.textContent = ''; });
  });
})();
